export const VerticalEllipsisIcon = ({ ...props }) => {
  return (
    <svg viewBox="0 0 192 512" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="m96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zm-72-104c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z" />
    </svg>
  );
};
